<div class="estimate-main-list-page">
    <div class="wrap">
    <!-- Top -->
    <div class="top">
        <div class="top-left">
            <div class="plate">{{ vehicleData?.registrationNumber }}{{selectedMake }}</div>
            <div class="subtitle">{{ vehicleData?.make }}{{selectedModel }} {{ vehicleData?.year }}{{selectedYear }} · {{ vehicleData?.fuel }}{{selectedFuelType }}</div>
            <div class="badges">
                <span class="badge blue"><span class="material-icons" style="font-size:16px;line-height: normal;">🏆</span>Autoverse Assured</span>
                <span class="badge green"><span class="material-icons" style="font-size:16px;line-height: normal;">✓</span> Genuine Parts</span>
                <span class="badge yellow"><span class="material-icons" style="font-size:16px;line-height: normal;">💰</span> Transparent Pricing</span>
                <span class="badge purple"><span class="material-icons" style="font-size:16px;line-height: normal;">🛡️</span> Warranty Support</span>
            </div>
        </div>
        <div class="btn-change" (click)="goToRegistrationDecode()">Change Car</div>
    </div>

    <div class="main-class">
        <!-- Sidebar -->
        <aside class="side">
            <h4>Service Categories</h4>
            <ul class="cat">
                <li *ngFor="let cat of categories" 
                    [class.active]="selectedCategoryId === cat.id" 
                    (click)="selectCategory(cat.id)">
                <div class="icon-and-text">
                    <span>{{ cat.icon || '🔧' }}</span>
                    <span class="small-text">{{ cat.name }}</span>
                </div>
                <span class="count">{{ cat.subCategoryCount || 0 }}</span>
                </li>
            </ul>
        </aside>


        <!-- Main -->
        <main class="main">
            <!-- =====================sub-categories============== -->
             <div class="seg" role="tablist">
                <button *ngFor="let sub of filteredSubCategories" 
                    [class.active]="sub.id === selectedSubCategoryId" 
                    (click)="selectSubCategory(sub.id)">
                    {{ sub.name }}
                </button>
            </div>

        <!-- Search box -->
        <div class="search">
            <span class="material-icons">search</span>
            <input [(ngModel)]="searchQuery" placeholder="Search services in this category..." style="color: black !important; background: none;" />
            <!-- <span *ngIf="searchQuery" class="material-icons clear-icon" (click)="searchQuery = ''">close</span> -->
            <span *ngIf="searchQuery" class="material-icons clear-icon" (click)="clearSearch()">close</span>
        </div>

        <!-- <div class="info">
            <span class="material-icons" style="color: black;">info</span>
            <div>
            <strong>OEM parts by default for guaranteed fit.</strong>
            <div style="margin-top:4px">
                Switch to OES for the same performance at a smarter price —
                <span class="chip">save up to ₹450</span> without compromising quality. Savings are shown clearly on every part.
            </div>
            </div>
        </div> -->
        <div class="Price-info">
            <div>
            <strong> 💡 Price shown includes labour only. Parts cost will be shown on the details page.</strong>
            </div>
        </div>
        
        

        <!-- Services List -->
        <section class="cards">
            <article class="card" *ngFor="let service of filteredServices"  style="cursor: pointer;">
            <!-- <div class="card-head" (click)="goToEstimateDetails(service)">{{ service.category }}</div> -->
            <img src="../../../assets/img/estimate-image.jpg" (click)="goToEstimateDetails(service)">
            <div class="card-body">
                <div class="svc-title">{{ service.title }}</div>
                <!-- <div class="price">From {{ service.price }}</div> -->
                <div class="price">From {{ service.labourTotal }}</div>
                <div class="incl">
                <!-- <div class="svc-sub">Incl. parts + labour</div> -->
                <span class="tag warn">⏱ 90–120 mins</span>
                </div>
                <div class="row-tags">
                    <!-- <span class="tag" *ngFor="let tag of service.tags">{{ tag }}</span> -->
                    <!-- hardcoded tags -->
                    <span class="ganuine-tag">Genuine Parts</span>
                    <span class="assured-tag">Autoverse Assured</span>
                </div>
                <!-- <div class="btn-group">
                    <button class="btn ghost">Price Breakdown</button>
                    <button 
                        class="btn" 
                        [ngClass]="{'primary': !isInEstimate(service), 'added': isInEstimate(service)}" 
                        (click)="addToEstimate(service)"
                        [disabled]="isInEstimate(service)">
                        {{ isInEstimate(service) ? 'Added ✓' : 'Add to Estimate' }}
                    </button>
                </div> -->

                <div class="btn-group">
                    <button class="btn-vew-detals" (click)="goToEstimateDetails(service)" >View Details </button>
                </div>

            </div>
            </article>
        </section>
        <section *ngIf="noServicesFound" class="no-service">
            <div style="text-align: center; margin-top: 20px;">
                <p style="font-size: 16px; color: #555;">No services found for this category and subcategory.</p>
            </div>
        </section>

        </main>


        <!-- Estimate Sidebar -->
        <!-- <aside class="est">
            <div class="est-head">
                <h4 id="est-heading">{{ estimateList.length ? 'My Service Estimate' : 'Your Service Estimate' }}</h4>
                <button type="button" class="clear" *ngIf="estimateList.length" (click)="clearEstimate()">Clear all</button>

            </div>

            <div id="empty-state" *ngIf="estimateList.length === 0" class="empty-estimate">
                <div style="font-size: 40px; text-align:center;">🛠️</div>
                <p style="text-align:center; font-weight: 500;">No services selected</p>
                <p style="text-align:center; font-size: 13px; color:#777;">
                Add services to build your estimate
                </p>
            </div>

            <div id="estimate-list" *ngIf="estimateList.length > 0">
                <div class="svc-card" *ngFor="let item of estimateList">
                <div class="svc-title">
                    <div class="left">
                    <div class="name">{{ item.title }}</div>
                    <div class="price">{{ item.price }}</div>
                    </div>
                    <div class="right">
                    <button class="remove material-icons" (click)="removeFromEstimate(item)">close</button>
                    <div class="qty-row">
                        <button class="qty-btn" (click)="toggleQuantity(item, -1)">-</button>
                        <span>{{ item.quantity }}</span>
                        <button class="qty-btn" (click)="toggleQuantity(item, 1)">+</button>
                    </div>
                    </div>
                </div>
                <div class="svc-sub">{{ item.time }}</div>
                </div>
            </div>

            <div id="estimate-details" *ngIf="estimateList.length > 0">
                <div class="splits">
                <div class="split"><span>Subtotal:</span><strong id="subtotal">₹0</strong></div>
                <div class="split green"><span>Discount (5%)</span><strong id="discount">-₹0</strong></div>
                <div class="split"><span>Tax (18%)</span><strong id="tax">₹0</strong></div>
                </div>
                <div class="total">
                <span>Total:</span><span class="amt" id="total">₹0</span>
                </div>
                <div class="gst">You can switch to OES in the breakdown to save more.</div>
                <button class="btn-save">Save Estimate</button>
                <button class="btn-pdf"  (click)="downloadPDF()" >Download PDF</button>
                <button class="btn-pdf"><mat-icon class="material-icons">share</mat-icon> Share</button>
                <div class="note">
                This is an estimate. Final invoice may vary after inspection,
                selected brands, taxes, and regional factors.
                </div>
            </div>
        </aside> -->

    </div>
    </div>
</div>


<app-loading *ngIf="loading"></app-loading>